null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala/scala/v2.12.10/src/library/scala/collection/generic/GenericCompanion.scala